var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content nfs-page" },
    [
      _c(
        "div",
        { staticClass: "row-data nfs-toolbar-card" },
        [
          _vm._m(0),
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "nfs-form-grid",
              attrs: { model: _vm.dataSearch, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                { staticClass: "nfs-form-item", attrs: { label: "Hiển thị" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px" },
                      attrs: { clearable: "", placeholder: "Hiển thị" },
                      on: {
                        change: function ($event) {
                          return _vm.searchHeaderMethod()
                        },
                      },
                      model: {
                        value: _vm.dataSearch.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "active", $$v)
                        },
                        expression: "dataSearch.active",
                      },
                    },
                    _vm._l(_vm.activeList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { value: item.key, label: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "nfs-form-item", attrs: { label: "Phạm vi" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px" },
                      attrs: { clearable: "", placeholder: "Phạm vi" },
                      on: {
                        change: function ($event) {
                          return _vm.searchHeaderMethod()
                        },
                      },
                      model: {
                        value: _vm.dataSearch.scope,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "scope", $$v)
                        },
                        expression: "dataSearch.scope",
                      },
                    },
                    _vm._l(_vm.scopeList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "nfs-form-item",
                  attrs: { label: "Thời gian tạo" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "260px" },
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      format: "dd-MM-yyyy",
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "-",
                      "start-placeholder": "Ngày bắt đầu",
                      "end-placeholder": "Ngày kết thúc",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.searchHeaderMethod()
                      },
                    },
                    model: {
                      value: _vm.dataSearch.dateList,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "dateList", $$v)
                      },
                      expression: "dataSearch.dateList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "nfs-form-item",
                  attrs: { label: "Tìm kiếm tiêu đề" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "270px" },
                    attrs: {
                      placeholder: "Nhập tiêu đề tìm kiếm",
                      clearable: "",
                    },
                    on: {
                      clear: function ($event) {
                        return _vm.searchHeaderMethod()
                      },
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchHeaderMethod()
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _c("el-button", {
                              attrs: { icon: "el-icon-search" },
                              on: {
                                click: function ($event) {
                                  return _vm.searchHeaderMethod()
                                },
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.dataSearch.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "title", $$v)
                      },
                      expression: "dataSearch.title",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "row-data nfs-table-card" }, [
        _c("div", { staticClass: "nfs-card-head" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "button-click" },
            [
              _c(
                "el-button",
                {
                  staticClass: "button-over",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createNotifyDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v("\n          Tạo tin tức\n        "),
                ]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "nfs-table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingData,
                    expression: "loadingData",
                  },
                ],
                staticClass: "sk-table",
                attrs: {
                  "empty-text": _vm.textTable,
                  "element-loading-text": _vm.$tableLoading,
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(255,255,255, 0)",
                  data: _vm.responseDataList,
                  "highlight-current-row": "",
                  border: "",
                  "max-height": _vm.$tableMaxHeight,
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "50",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createdDate",
                    width: "155px",
                    label: "Thời gian tạo",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDateTime")(scope.row.createdDate)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "160px",
                    label: "Người gửi",
                    prop: "createdBy",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { staticClass: "font-semibold text-slate-700" },
                            [_vm._v(_vm._s(scope.row.createdBy))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "scope",
                    label: "Phạm vi",
                    width: "100px",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatScope(scope.row.scope))),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "title",
                    label: "Tiêu đề",
                    "min-width": "250px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "nfs-title-link",
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.title) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { width: "100px", label: "Số File", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.notifySchoolAttachFileList.length > 0
                            ? _c("span", { staticClass: "nfs-file-badge" }, [
                                _c("i", { staticClass: "el-icon-document" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.notifySchoolAttachFileList
                                        .length
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _c("span", { staticClass: "text-slate-400" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "active",
                    width: "100px",
                    label: "Hiển thị",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-checkbox", {
                            staticClass: "nfs-table-checkbox",
                            attrs: {
                              disabled:
                                (_vm.checkCountActive === _vm.checkedCount &&
                                  scope.row.active === true) ||
                                scope.row.approved === false,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.getActiveNotifySchool(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.active,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "active", $$v)
                              },
                              expression: "scope.row.active",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "approved",
                    width: "100px",
                    label: "Duyệt",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-checkbox", {
                            staticClass: "nfs-table-checkbox",
                            on: {
                              change: function ($event) {
                                return _vm.getApprovedNotifySchool(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.approved,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "approved", $$v)
                              },
                              expression: "scope.row.approved",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "155px",
                    label: "Thời gian gửi",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.scheduledTime
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDateTime")(
                                      scope.row.scheduledTime
                                    )
                                  )
                                ),
                              ])
                            : _c("span", { staticClass: "text-slate-400" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    width: "135px",
                    label: "Trạng thái gửi",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            { class: _vm.getStatusBadgeClass(scope.row) },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formatNotifySendStatus(scope.row)
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Ghim", align: "center", width: "90px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-checkbox", {
                            staticClass:
                              "nfs-table-checkbox nfs-table-checkbox--pin",
                            attrs: {
                              disabled: !scope.row.pin && _vm.countPostPin >= 5,
                            },
                            on: {
                              change: (value) =>
                                _vm.handleChangePin(scope.row, value),
                            },
                            model: {
                              value: scope.row.pin,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "pin", $$v)
                              },
                              expression: "scope.row.pin",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tác vụ",
                    fixed: "right",
                    width: "120px",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Chỉnh sửa tin tức",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Xóa tin tức",
                                placement: "top",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "ml-1",
                                attrs: {
                                  type: "danger",
                                  icon: "el-icon-delete",
                                  size: "mini",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "nfs-pagination" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.pageNumber,
                "page-sizes": _vm.$pageListDefaultNew,
                "page-size": _vm.maxPageItem,
                layout: _vm.$pageLayoutDefault,
                total: _vm.pageTotal,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("CreateNotifySchool", {
        ref: "CreateNotifySchool",
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
      _c("UpdateNotifySchool", {
        ref: "UpdateNotifySchool",
        attrs: { dialogVisible: _vm.showUpdateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseUpdateMethod()
          },
        },
      }),
      _c("SetTimePostPinExpiration", {
        ref: "SetTimePostPinExpiration",
        attrs: { "is-dialog-visible": _vm.isDialogVisible.setTimePostPin },
        on: { dialogClose: _vm.handleDialogSetTimeClose },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nfs-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "nfs-card-title" }, [
          _vm._v("Tin tức nhà trường"),
        ]),
        _c("p", { staticClass: "nfs-card-subtitle" }, [
          _vm._v(
            "Tìm kiếm các thông báo, tin tức được gửi tới toàn bộ phụ huynh và học sinh."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "nfs-card-title" }, [_vm._v("Danh sách bản tin")]),
      _c("p", { staticClass: "nfs-card-subtitle" }, [
        _vm._v(
          "Hiển thị thông tin người gửi, số tệp đính kèm và các cấu hình trạng thái của tin tức."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }